import { createUseStyles } from 'react-jss';

const styles = {
  sidebar: {
    overflowX: 'visible',
    maxHeight: '100%',
  },
  // Keyframes:
  '@keyframes slideDown': {
    from: { top: '-5.6rem', zIndex: '1002' },
    to: { top: '6.5rem', zIndex: '1002' },
  },
};
const createStyles = createUseStyles(styles);

export { createStyles };
